import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './styles/LandingPage.css';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const handleViewDemo = () => {
    navigate('/dashboard');
  };

  const handleRequestDemo = () => {
    console.log('Request demo clicked');
  };

  const buttonClass = `primary-cta ${isHovered ? 'hovered' : ''}`;

  return (
    <div className="landing-page">
      <div className="background-elements">
        <div className="gradient-circle-1"></div>
        <div className="gradient-circle-2"></div>
        <div className="grid-pattern"></div>
      </div>

      <main className="main-content">
        {/* Header - WITH PROPERLY SIZED LOGO */}
        <header className="header">
          <div className="logo">
            {/* Container that matches your original ⚡ icon styling */}
            <div className="logo-icon-container">
              <img 
                src="/resources/prometheus_logo.jpg" 
                alt="Prometheus"
                className="logo-image"
              />
            </div>
            <div className="logo-text">
              <span className="logo-primary">PROMETHEUS</span>
              <span className="logo-secondary">Workforce Analytics</span>
            </div>
          </div>
          
          <nav className="nav">
            <button className="nav-button" onClick={handleViewDemo}>
              Live Demo
            </button>
          </nav>
        </header>

        {/* Rest of your original code remains EXACTLY THE SAME */}
        <div className="hero-section">
          <div className="hero-left">
            <div className="badge">
              <span className="badge-dot">●</span>
              AI-Powered Risk Intelligence
            </div>

            <h1 className="headline">
              Predict & Prevent
              <span className="headline-highlight"> Employee Turnover </span>
              with AI
            </h1>

            <p className="subheadline">
              Prometheus Workforce Analytics uses real-time AI to identify flight risks,
              score employees from 0–100, and guide targeted interventions —
              <strong> helping HR leaders save millions in replacement costs.</strong>
            </p>

            <div className="cta-container">
              <button
                className={buttonClass}
                onClick={handleViewDemo}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <span className="cta-text">View Live Demo →</span>
                <span className="cta-subtext">No signup required</span>
              </button>

              <button
                className="secondary-cta"
                onClick={handleRequestDemo}
              >
                Request Enterprise Demo
              </button>
            </div>

            <div className="stats">
              <div className="stat-item">
                <div className="stat-number">95%</div>
                <div className="stat-label">Prediction Accuracy</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">200+</div>
                <div className="stat-label">Employees Analyzed</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">$2.4M</div>
                <div className="stat-label">Potential Savings</div>
              </div>
            </div>
          </div>

          <div className="hero-right">
            <div className="dashboard-preview">
              <div className="preview-header">
                <div className="preview-title">
                  <span className="preview-icon">���</span>
                  Live Risk Dashboard
                </div>
                <div className="preview-badge">
                  <span className="live-dot">●</span> LIVE
                </div>
              </div>

              <div className="gauge-container">
                <div className="gauge">
                  <div className="gauge-needle"></div>
                  <div className="gauge-score">41</div>
                </div>
                <div className="gauge-label">Overall Risk Score</div>
              </div>

              <div className="risk-distribution">
                <div className="risk-bar">
                  <div className="risk-label">Critical</div>
                  <div className="risk-value-container">
                    <div className="risk-value-bar critical"></div>
                    <div className="risk-value">23</div>
                  </div>
                </div>
                <div className="risk-bar">
                  <div className="risk-label">High</div>
                  <div className="risk-value-container">
                    <div className="risk-value-bar high"></div>
                    <div className="risk-value">30</div>
                  </div>
                </div>
                <div className="risk-bar">
                  <div className="risk-label">Medium</div>
                  <div className="risk-value-container">
                    <div className="risk-value-bar medium"></div>
                    <div className="risk-value">38</div>
                  </div>
                </div>
              </div>

              <button
                className="preview-cta"
                onClick={handleViewDemo}
              >
                Explore Full Dashboard
              </button>
            </div>
          </div>
        </div>

        <div className="tech-stack">
          <div className="tech-label">Powered by:</div>
          <div className="tech-icons">
            <div className="tech-icon">���</div>
            <div className="tech-icon">���</div>
            <div className="tech-icon">⚡</div>
          </div>
          <div className="tech-names">
            <span>AI/ML</span>
            <span className="tech-divider">•</span>
            <span>MongoDB Atlas</span>
            <span className="tech-divider">•</span>
            <span>Real-time Analytics</span>
          </div>
        </div>
      </main>
    </div>
  );
};

export default LandingPage;
